module.exports = __webpack_public_path__ + "static/media/Double Ring-2s-200px.433ea68a.svg";